import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastService } from '../../../services/toast-service';
import { CalibrantLoadModule } from '../../shared/calibrant-load/calibrant-load.module';
import { SiteHomeComponent } from "./site-home.component";
import { SiteFinancialModule } from "../site-financial/site-financial.module";
import { SiteDevicesModule} from "../site-devices/site-devices.module";
import { SiteOperationsModule } from '../site-operations/site-operations.module';
import { MatTabsModule } from "@angular/material/tabs";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@NgModule({ declarations: [
        SiteHomeComponent,
    ],
    exports: [
        SiteHomeComponent,
    ], imports: [CommonModule,
    RouterModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    CalibrantLoadModule,
    SiteDevicesModule,
    SiteFinancialModule,
    MatTabsModule,
    SiteOperationsModule
  ], providers: [
        ToastService,
        provideHttpClient(withInterceptorsFromDi()),
    { provide: MAT_DIALOG_DATA, useValue: {} }
    ] })
export class SiteHomeModule { }
